import {ANALYTICS_SOURCE_TYPES, ANALYTICS_MAX_ERROR_LENGTH} from '../constants';

function truncateErrorDesc(desc) {
  return desc.length > ANALYTICS_MAX_ERROR_LENGTH
    ? `${desc.substring(0, ANALYTICS_MAX_ERROR_LENGTH)}...`
    : desc;
}

function fromErrorObject(error) {
  if (!error) {
    console.warn('Invalid error data for error event:', error);
    return {errorDesc: 'Unknown error'};
  }

  const errorDesc = `${error.name || 'Error'}: ${error.message || 'No message'}`;
  return {errorDesc: truncateErrorDesc(errorDesc)};
}

function fromFetchBaseQueryError(error) {
  if (!error) {
    console.warn('Invalid fetch base query error data for error event:', error);
    return {errorDesc: 'Unknown fetch error'};
  }

  let dataStr = 'No additional error data';
  if (error.data != null) {
    try {
      dataStr = typeof error.data === 'string'
        ? error.data
        : JSON.stringify(error.data);
    } catch {
      dataStr = 'Error data unavailable (circular reference or too large)';
    }
  }

  const errorDesc = `FetchBaseQueryError - Status ${error.status || 'unknown'}: ${dataStr}`;
  return {errorDesc: truncateErrorDesc(errorDesc)};
}

export const mapErrorEvent = (source, options = {}) => {
  switch (options.sourceType) {
    case ANALYTICS_SOURCE_TYPES.FETCH_BASE_QUERY_ERROR:
      return fromFetchBaseQueryError(source);
    case ANALYTICS_SOURCE_TYPES.ERROR:
      return fromErrorObject(source);
    default:
      return source;
  }
};
